export { MainTabBar } from './MainTabBar';
